export const INCREASE_LOAN_AMOUNT_BANNER_PRODUCT_INDEX = 1
